"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
"use strict";
var debug = require('debug')('knack-field-predictor-image');
var validator = require('validator');
var BasePredictor = require('./base.predictor.js');
var valid_image_file_extensions = ['bmp', 'bpg', 'gif', 'ico', 'jfif', 'jpg', 'jpeg', 'png', 'svg', 'tiff', 'webp'];
var evaluations = [{
  // criteria: new RegExp(/^<img.+src=\s*"(\S+\.(\w+))".*>$/i),
  criteria: new RegExp(/^<img.+src=\s*"(\S+\/(\S+\.([^"?]+)))\S*".*>$/i),
  format: {
    source: 'upload',
    thumbs: []
  }
}, {
  criteria: new RegExp("^((?:https?\\:\\/{2})?[^./]+(?:\\.[^./]+)+(?:\\S*)?\\/(\\S+.(".concat(valid_image_file_extensions.join('|'), "))(?:\\?.+)*)$"), 'i'),
  format: {
    source: 'upload',
    thumbs: []
  }
}];
var ImagePredictor = /*#__PURE__*/function (_BasePredictor) {
  function ImagePredictor() {
    _classCallCheck(this, ImagePredictor);
    return _callSuper(this, ImagePredictor, ['image']);
  }
  _inherits(ImagePredictor, _BasePredictor);
  return _createClass(ImagePredictor, [{
    key: "predict",
    value: function predict(value) {
      var _this = this;
      debug("Testing value: ".concat(value));
      if (value === null || typeof value === 'undefined' || typeof value !== 'string') {
        debug('value was null, undefined, or not a string');
        return this.prediction;
      }
      evaluations.forEach(function (evaluation) {
        if (_this.is_match) {
          return;
        }
        debug("Testing evaluation: ".concat(JSON.stringify(evaluation)));
        var match = value.match(evaluation.criteria);
        if (match === null || match.length !== 4) {
          debug('The regex test did not pass, moving on.');
          return;
        }
        debug("match is: ".concat(JSON.stringify(match)));
        var source = match[1];
        var file_name = match[2];
        var extension = match[3];
        debug("source has been set to ".concat(source));
        debug("file_name has been set to ".concat(file_name));
        debug("extension has been set to ".concat(extension));
        if (!valid_image_file_extensions.includes(extension) || !validator.isURL(source)) {
          debug('The initial regex passed but the result wasn\'t a URL, moving on.');
          return;
        }
        debug('evaluation criteria passed!');
        _this.is_match = true;
        _this.format = evaluation.format;
      });
      return this.prediction;
    }
  }]);
}(BasePredictor);
module.exports = ImagePredictor;